export const DIETARY_PREFERENCES_KEY = 'DIETARY_PREFERENCES';
